var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { StepLayout } from './step-layout.component';
import { GenderSelectContent } from './gender-select-content.component';
import { pageImages } from '@/pages/images';
import { LogoAndHeading } from './logo-and-heading.component';
import { InformationToggle } from './information-toggle.component';
import { Typography } from '@mui/material';
import { palette } from '@/theme/palette';
import { useSendButtonClick } from '@/hooks/use-send-button-click.hook';
export function GenderSelect() {
    var handleSendButtonClick = useSendButtonClick().handleSendButtonClick;
    return (_jsx(StepLayout, { image: pageImages.familySmiling, heading: _jsx(LogoAndHeading, { headingText: 'Select your gender at birth.', className: "text-lg md:text-2xl", image: {
                height: 110,
                width: 118,
            } }), progress: {
            phase: 0,
            step: 2,
        }, content: _jsx(GenderSelectContent, {}), info: _jsx(InformationToggle, __assign({ title: 'Why ask my gender?', chevronColor: palette.primary.main, onClick: function () { return handleSendButtonClick('why_ask_my_gender'); } }, { children: _jsx(Typography, __assign({ className: 'text-xs md:text-base' }, { children: "Hearing frequency ranges vary by biological gender (male & female). While this information provides useful context, it does not impact the accuracy of your hearing assessment results." })) })) }));
}
